import { configure } from "@testing-library/react";
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import kiosksReducer from "./slices/kioskSlice";
import videoReducer from "./slices/videoSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  kiosk: kiosksReducer,
  video: videoReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "kiosk", "video"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  // middleware: [thunk],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
